import { render, staticRenderFns } from "./regpage.vue?vue&type=template&id=393e3610&scoped=true"
import script from "./regpage.vue?vue&type=script&lang=js"
export * from "./regpage.vue?vue&type=script&lang=js"
import style0 from "./regpage.vue?vue&type=style&index=0&id=393e3610&lang=css"
import style1 from "./regpage.vue?vue&type=style&index=1&id=393e3610&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393e3610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393e3610')) {
      api.createRecord('393e3610', component.options)
    } else {
      api.reload('393e3610', component.options)
    }
    module.hot.accept("./regpage.vue?vue&type=template&id=393e3610&scoped=true", function () {
      api.rerender('393e3610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/landingpage/regpage.vue"
export default component.exports